import React from 'react'
import { Avatar } from '@mui/material'

export default function ProfilePicture({ firstName }: { firstName: string }) {
  const avatarText = firstName ? firstName.charAt(0) : ':..:'
  return <Avatar sx={{ mr: 1 }}>{avatarText}</Avatar>
}
